const ValueProposition = () => {
  return (
    <div className="py-16 sm:py-20 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Why Our Customers Choose Zbox</h2>
        </div>
        <div className="mx-auto max-w-2xl lg:max-w-none mt-12">
          <div className="grid grid-cols-1 gap-y-16 gap-x-8 text-center lg:grid-cols-3">
            {/* Availability */}
            <div className="group relative transform transition-all duration-200 hover:scale-105">
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 group-hover:bg-[#FFE81A]/10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-8 w-8 text-[#FFE81A] group-hover:text-[#EEDA2B]"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
              </div>
              <h3 className="mt-6 text-xl font-semibold leading-7 tracking-tight text-gray-900">Parts Availability</h3>
              <p className="mt-2 text-base leading-7 text-gray-600">
                Access our extensive inventory of heavy-duty parts whenever you need them.
              </p>
            </div>

            {/* Smart Search */}
            <div className="group relative transform transition-all duration-200 hover:scale-105">
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 group-hover:bg-[#FFE81A]/10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-8 w-8 text-[#FFE81A] group-hover:text-[#EEDA2B]"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
                  />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.008v.008H6V6Z" />
                </svg>
              </div>
              <h3 className="mt-6 text-xl font-semibold leading-7 tracking-tight text-gray-900">Competitive Pricing</h3>
              <p className="mt-2 text-base leading-7 text-gray-600">
                Quality parts at competitive prices to help you maximize your equipment investment.
              </p>
            </div>

            {/* Expert Support */}
            <div className="group relative transform transition-all duration-200 hover:scale-105">
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 group-hover:bg-[#FFE81A]/10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-8 w-8 text-[#FFE81A] group-hover:text-[#EEDA2B]"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                  />
                </svg>
              </div>
              <h3 className="mt-6 text-xl font-semibold leading-7 tracking-tight text-gray-900">Expert Support Team</h3>
              <p className="mt-2 text-base leading-7 text-gray-600">
                Get personalized assistance from our experienced team for all your equipment needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValueProposition;
